module.exports = __webpack_public_path__ + "static/media/Gilroy-Regular.31ff7c1a.ttf";